import React from "react";
import Button from "components/Button";
import Input from "components/Input";
import appLogo from "assets/logo/logo-only.png";
import "./index.scss";

const StripePage = () => (
  <div className="stripe-wrapper">
    <div className="header-panel">
      <span className="icon-image" />
      <h1 className="title">High Resolution Ordering</h1>
      <img className="app-logo" src={appLogo} alt="alt" />
    </div>
    <div className="main-container">
      <h2 className="page-title">Payment</h2>
      <div className="total-price">
        <label className="label">Total Price</label>
        <h2 className="price">$ 480.00</h2>
        <label className="label">GST Inclusive</label>
      </div>
      <div className="bubble-wrap -error">
        Your card has been declined. Please check your card information and try
        it again.
      </div>
      <div className="bubble-wrap -success">
        Payment is successful. You will be redirected within a few seconds.
      </div>
      <div className="group-wrapper">
        <p className="title">Processing Payment</p>
        <p className="description">
          It may take a few seconds to process your payment, Please wait.
        </p>
        <span className="icon-refresh" />
      </div>
      <div className="group-wrapper">
        <p className="title">Payment Successful</p>
        <span className="icon-check" />
      </div>
      <div className="group-wrapper">
        <p className="title -input">Payment Information</p>
        <div className="input-group -solo">
          <Input label="Card Number" />
        </div>
        <div className="input-group">
          <Input label="Expiration Date" />
          <Input label="CVV" />
        </div>
        <div className="input-group -solo">
          <Input label="Country" />
        </div>
        <div className="button-group">
          <Button label="Pay $480.00" type="solid" color="blue" block />
          <Button label="Go Back" type="outlined" color="black" block />
        </div>
      </div>
    </div>
  </div>
);

export default StripePage;
